import React, { useState, useEffect } from 'react'
import clsx from 'clsx'

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/en';
import 'dayjs/locale/nb';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

interface Props {
    label: string,
    zone: string,
    background: string,
    key?: number,
}

export default function Clock(props: Props) {
    const { label, zone, background } = props

    const [time, setTime] = useState(dayjs().tz(zone))
    const [hourDegrees, setHourDegrees]: any = useState()
    const [minuteDegrees, setMinuteDegrees]: any = useState()
    const [clockTime, setClockTime]: any = useState()
    const [date, setDate]: any = useState()

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(dayjs().tz(zone))
        }, 1000)

        return () => clearInterval(interval)
    }, [zone])

    useEffect(() => {
        const hour = time.hour()
        const minute = time.minute()

        setHourDegrees((hour % 12) * 30 + minute * 0.5)
        setMinuteDegrees(minute * 6)

        setDate(time.format('ddd D MMM').toUpperCase())
        setClockTime(time.format('HH:mm'))
    }, [time])

    return (
        <div className='clock'>
            <div className='clock__analog' aria-hidden='true'>
                <img className='analog-background' src={background} alt='' loading='lazy' />
                <div className="analog-hand analog-hand--hour" style={{ transform: `rotate(${hourDegrees ?? 0}deg)`}}></div>
                <div className="analog-hand analog-hand--minute" style={{transform: `rotate(${minuteDegrees ?? 0}deg)`}}></div>
            </div>
            <div className="clock__info-wrapper">
                <div className='clock__location'>{label}</div>
                <div className='clock__date'>{date}</div>
                <div className='clock__time'> {clockTime} </div>
            </div>
        </div>
    )
}
